var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 106,
    viewBox: "0 0 95 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5921 101.069C17.259 87.8681 10.6801 59.9286 23.8813 38.5943C37.0825 17.2599 65.0215 10.6794 86.3546 23.8798",
    stroke: "#0A223C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9469 29.3868C64.6582 18.0702 40.7052 23.7119 29.388 42.0017C18.0707 60.2915 23.711 84.2448 41.9997 95.5614",
    stroke: "#0A223C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4166 90.0394C30.1798 80.6112 25.4735 60.6516 34.9069 45.4063C44.3402 30.1611 64.295 25.4611 79.5393 34.8939",
    stroke: "#0A223C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8627 70.3742C52.3172 67.5616 50.9126 61.5965 53.7254 57.0507C56.5381 52.505 62.5032 51.1001 67.0487 53.9127C71.5941 56.7253 72.9987 62.6904 70.1859 67.2362C67.3731 71.7819 61.4081 73.1869 56.8627 70.3742Z",
    fill: "#842DDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/vector-3.6df61e1e6d7037058ffc8299657f03b6.svg";
export { ForwardRef as ReactComponent };